import { render } from "./CreateProductionOrder.vue?vue&type=template&id=ec97826a"
import script from "./CreateProductionOrder.vue?vue&type=script&lang=js"
export * from "./CreateProductionOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__